export default function () {
	const DEV = import.meta.env.DEV
	console.log('\x1b[32m.\x1b[37mNovadata\x1b[0m')

	console.log(
		'%c Venha trabalhar conosco! ',
		'background: #00c853; color: #fff; font-size: 14px; padding: 4px 8px; border-radius: 4px;'
	)
	console.log('%chttps://conecta.novadata.com.br/', 'color: #00c853; font-size: 12px;')
}
